export const CURRENT_LOCATIONID = 'CURRENT_LOCATIONID';
